import { ESSearchHeader } from '@/Core/config/es-search-header';
import { feathers } from '@/feathers-client';
import customErrors from '@/Core/config/errors';

export default {
  namespaced: true,
  state: {
    total: 0,
    isLoading: false,
    hasError: false,
    errorMsg: '',
  },
  mutations: {
    setTotal(state, total) {
      state.total = total;
    },
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
    setError(state, err) {
      state.errorMsg = err;
      state.hasError = true;
      state.isLoading = false;
    },
    clearMessage(state) {
      state.errorMsg = '';
      state.hasError = false;
      state.isLoading = false;
    },
  },
  actions: {
    async findTotalContactsByResource({ commit }, resource = {}) {
      const query = {
        $limit: 1,
        $and: [
          {
            $or: [resource],
          },
        ],
      };
      try {
        commit('setIsLoading', true);
        const { total } = await feathers
          .service('cached-contacts/search')
          .create({ query }, { headers: ESSearchHeader });
        commit('setTotal', total);
      } catch (error) {
        if (error.code === 400) {
          error.message = customErrors[error.code];
        }
        commit('setTotal', 0);
        commit('setError', error.message);
      }
    },
  },
};
